interface Props {
  label: string;
  options: string[];
  selectedValues: string[];
  onChange: (values: string[]) => void;
  testId: string;
}

const HullCleaningFilterCheckboxGroup = ({ label, options, selectedValues, onChange, testId }: Props) => {
  const toggleValue = (value: string) => {
    onChange(
      selectedValues.includes(value)
        ? selectedValues.filter((selectedValue) => selectedValue !== value)
        : [...selectedValues, value],
    );
  };

  return (
    <fieldset data-test={testId} className="min-w-0">
      <legend className="mb-1.5 text-xs font-medium text-gray-600 dark:text-gray-300">{label}</legend>
      <div className="max-h-28 space-y-1 overflow-y-auto rounded-lg border border-gray-300 bg-white px-2 py-1.5 dark:border-gray-600 dark:bg-gray-700">
        {options.length === 0 && <p className="py-1 text-[11px] text-gray-400">No values</p>}
        {options.map((option) => (
          <label key={option} className="flex cursor-pointer items-center gap-2 py-0.5 text-[11px]">
            <input
              type="checkbox"
              checked={selectedValues.includes(option)}
              onChange={() => toggleValue(option)}
              className="h-3.5 w-3.5 rounded border-gray-300 text-green focus:ring-green"
            />
            <span className="truncate" title={option}>{option}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};

export default HullCleaningFilterCheckboxGroup;
